import { render, staticRenderFns } from "./radialChart.vue?vue&type=template&id=4c5239b6&scoped=true"
import script from "./radialChart.vue?vue&type=script&lang=js"
export * from "./radialChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5239b6",
  null
  
)

export default component.exports